import { createSlice } from "@reduxjs/toolkit"
import { SLICE_NAME } from "constants/common"

const initialState = {
    backgroundSystem: undefined,
    blurBackground: undefined,
    primaryColor: undefined,
    secondaryColor: undefined,
    textColor: undefined,
    isDefaultTheme: true,
    disabledSidebar: false
}

export const layoutSlice = createSlice({
    name: SLICE_NAME.LAYOUT,
    initialState,
    reducers: {
        setLayoutValue: (state, action) => {
            Object.assign(state, action.payload)
        },
        setBackgroundSystem: (state, action) => {
            if(action.payload) state.backgroundSystem = action.payload
        },
        setBlurBackground: (state, action) => {
            if(action.payload >= 0) state.blurBackground = action.payload
        },
        setPrimaryColor: (state, action) => {
            if(action.payload) state.primaryColor = action.payload
        },
        setSecondaryColor: (state, action) => {
            if(action.payload) state.secondaryColor = action.payload
        },
        setTextColor: (state, action) => {
            if(action.payload) state.textColor = action.payload
        },
        setIsDefaultTheme: (state, action) => {
            state.isDefaultTheme = action.payload
        },
        setDisabledSidebar: (state, action) => {
            state.disabledSidebar = action.payload
        }
    }
})

export const {
    setLayoutValue,
    setBackgroundSystem,
    setBlurBackground,
    setPrimaryColor,
    setSecondaryColor,
    setTextColor,
    setIsDefaultTheme,
    setDisabledSidebar
} = layoutSlice.actions

export default layoutSlice.reducer
